import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Center,
  Spinner,
  Text,
} from '@chakra-ui/react';
import { HOME_ROUTE } from 'config/AppRoutes';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useApiItems } from 'store/hooks/useApiItems';

export const PageWithApiItems = ({ children }: { children: JSX.Element }) => {
  const { items, error } = useApiItems();
  const leastDestructiveRef = useRef();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // ---------------- methods -----------------

  const handleErrorContine = () => {
    navigate(HOME_ROUTE);
  };

  // ---------------- render -----------------

  if (error) {
    return (
      <AlertDialog
        isOpen
        onClose={handleErrorContine}
        leastDestructiveRef={leastDestructiveRef}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {t('common.error.title')}
            </AlertDialogHeader>

            <AlertDialogBody>
              {t('common.error.description')}
              <br />
              <Text color="primaryColor" fontWeight="bold">
                <i color="red">{error?.message}</i>
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button colorScheme="red" onClick={handleErrorContine} ml={3}>
                {t('common.continue')}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    );
  }

  if (!items) {
    return (
      <Center h="70vh">
        <Spinner color="primaryColor" />
      </Center>
    );
  }
  return children;
};
